import cx from "classnames";

import { Models } from "api/types";
import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/chevron_right_small.svg";
import RepeatMD from "atoms/icon/icons/RepeatCash.svg";
import { formatCurrency } from "toolbox/Money";

export interface RepeatCashEntryProps {
  title: string;
  date: string | null | undefined;
  amount: number;
  transactionType: Models<"RepeatCashTransactionType">;
  onClick?: () => void;
  repeatCashType?: Models<"RepeatCashType"> | null;
}

export const RepeatCashEntry = (props: RepeatCashEntryProps) => {
  const isTransactionTypeCashSpent =
    props.transactionType == "CashSpent" ||
    props.transactionType == "CashWithdrawal";

  const renderRepeatCashTypeSubtitle = () => {
    switch (props.repeatCashType) {
      case "Gift":
        return "From your gift card";
      case "ReferralReward":
        return "From your referral reward";
      default:
        return null;
    }
  };

  const subtitle = renderRepeatCashTypeSubtitle();

  return (
    <button
      className={cx(
        "relative grid w-full grid-cols-12 items-center gap-4 border-b border-t border-gray-200 bg-white px-6 py-4",
        props.onClick ? "cursor-pointer" : "cursor-default"
      )}
      onClick={props.onClick ?? undefined}
    >
      <div className="col-span-7 text-left">
        <div
          className={cx(
            "flex min-h-[2.5rem] flex-col",
            subtitle ? "justify-center" : "items-center"
          )}
        >
          <p className="line-clamp-2 text-body1 capitalize text-primary">
            {props.title}
          </p>
          {subtitle && <p className="text-body3 text-secondary">{subtitle}</p>}
        </div>
      </div>
      <div className="col-span-4 flex items-center gap-2">
        <div className="flex items-start justify-start gap-2">
          <Icon svg={RepeatMD} color="primaryText" size="xsmall" />
        </div>
        <p
          className={cx(
            "text-body text-nowrap text-left font-sans",
            isTransactionTypeCashSpent ? "text-red" : "text-secondary"
          )}
        >
          {isTransactionTypeCashSpent ? "-" : ""}
          {formatCurrency(props.amount)}
        </p>
      </div>
      <div className={cx(props.onClick ? "" : "opacity-0", "col-span-1")}>
        <Icon svg={ChevronRight} color="brandColor" size="small" />
      </div>
    </button>
  );
};
